import { NO_ELEMENT } from 'utils';

export const SalesTakerModal = () => NO_ELEMENT;
